import React, { createContext, useState, useEffect } from 'react';
import translations from './translations';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'pl'); // Default to Polish

  useEffect(() => {
    localStorage.setItem('language', language); // Persist language in localStorage
  }, [language]);

  const t = (key) => translations[language][key] || key; // Translation function

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};